import { useMap } from "@/components/ui/map";
import { DiaSemana, } from "@/types/filter";
import { clsx } from "clsx";
import { useEffect } from "react";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
const diaSemanaMap = {
    SEGUNDA: "Segunda-feira",
    TERCA: "Terça-feira",
    QUARTA: "Quarta-feira",
    QUINTA: "Quinta-feira",
    SEXTA: "Sexta-feira",
    SABADO: "Sábado",
    DOMINGO: "Domingo",
};
export function formatDiaSemana(dia) {
    if (!dia)
        return null;
    return diaSemanaMap[dia] ?? null;
}
function getRouteCoordinates(route) {
    if (route.municipioPartida?.longitude == null ||
        route.municipioPartida?.latitude == null ||
        route.municipioDestino?.longitude == null ||
        route.municipioDestino?.latitude == null) {
        return null;
    }
    const start = [
        route.municipioPartida.longitude,
        route.municipioPartida.latitude,
    ];
    const end = [
        route.municipioDestino.longitude,
        route.municipioDestino.latitude,
    ];
    return [start, end];
}
function getBounds(coords) {
    let minLng = Infinity;
    let minLat = Infinity;
    let maxLng = -Infinity;
    let maxLat = -Infinity;
    coords.forEach(([lng, lat]) => {
        minLng = Math.min(minLng, lng);
        minLat = Math.min(minLat, lat);
        maxLng = Math.max(maxLng, lng);
        maxLat = Math.max(maxLat, lat);
    });
    return [
        [minLng, minLat],
        [maxLng, maxLat],
    ];
}
export function MapZoomToRoute({ selectedRoute, }) {
    const { map, isLoaded } = useMap();
    useEffect(() => {
        if (!map || !isLoaded || !selectedRoute)
            return;
        const coordinates = getRouteCoordinates(selectedRoute);
        if (!coordinates)
            return;
        const bounds = getBounds(coordinates);
        map.fitBounds(bounds, {
            padding: 120,
            duration: 1200,
        });
    }, [selectedRoute, map, isLoaded]);
    return null;
}
export function toPascalCase(text) {
    if (!text)
        return null;
    return text
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}
export const defaultCoordinates = [
    -42.12753407825606, -7.015062378112775,
]; // teresina
export const diaSemanaOptions = Object.values(DiaSemana).map((dia) => ({
    value: dia,
    label: dia.charAt(0) + dia.slice(1).toLowerCase(),
}));
export function empresasToSelectItems(empresas) {
    return empresas.map((e) => ({
        value: String(e.id),
        label: e.razaoSocial,
    }));
}
export function municipiosToSelectItems(municipios) {
    return municipios.map((m) => ({
        value: String(m.id),
        label: m.municipio,
    }));
}
